<template>
  <div>
    <md-card class="search-area">
      <md-card-header md-alignment="space-between">
        <h4 class="title">
          <md-icon>search</md-icon>
          검색 조건
        </h4>
      </md-card-header>
      <md-card-content>
        <table class="flex-table">
          <tr>
            <th>캠페인명</th>
            <td><input v-focus type="text" v-model="searchText"></td>
          </tr>
        </table>
      </md-card-content>

      <md-card-actions md-alignment="right">
        <md-button class="md-info md-sm" @click="sendQuery"><md-icon>check</md-icon>검 색</md-button>
      </md-card-actions>
    </md-card>

    <!-- 목록 시작 -->
    <md-card>
      <md-card-header md-alignment="space-between">
        <h4 class="title">
          <md-icon>assignment</md-icon>
          캠페인 목록
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="table-header-info">
          <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
          <div>
            <select v-model="pagination.perPage" name="pages" @change="perPageChange">
              <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>
        <grid ref="cmpListGrid"
              :data="gridProps.data"
              :columns="gridProps.columns"
              :options="gridProps.options"
              :theme="gridProps.theme"
              :rowHeaders="gridProps.rowHeaders"
              :columnOptions="gridProps.columnOptions"
              :language="gridProps.lang"
              @click="onClickList"
              @response="response"
        ></grid>
      </md-card-content>
      <slot name="bottomRightArea"></slot>
    </md-card>
  </div>
</template>
<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";
import Swal from "sweetalert2";
import moment from "moment";

import { Grid } from '@toast-ui/vue-grid';

export default {
  name: "cmpListComp",
  props: {
  },
  components: {
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      searchText : '',
      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
    };
  },
  methods: {
    sendQuery (){
      this.$refs.cmpListGrid.invoke("readData", 1, {cCustGrpNm:this.searchText});
    },
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_CMP_PREVIEW, false, this.pagination);
      this.gridProps['el'] = this.$refs.cmpListGrid;
      this.gridProps['columns'] = [
          {header: '캠페인ID', name: 'CCmpId', align : 'center', sortable: true},
          {header: '캠페인명', name: 'CCustGrpNm', align : 'center', sortable: true},
          {header: '설명', name: 'CCustGrpDesc', align : 'center'}
        ];
      this.gridProps['options'].bodyHeight = 300;
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.cmpListGrid, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
        this.$emit('gridRefresh');
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
    },
    onClickList(item){
      if(item.instance.getRow(item.rowKey) != null) {
        this.$emit('returnResult', item.instance.getRow(item.rowKey));
      }
		}
  }
};
</script>

<style lang="css" scoped>
</style>